import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../shared/form-elements/select/field';

const Form = (props) => {
	return (
		<div className="">
			<form className="position-relative top--20 min-width-200">
				<div className="ui-form__element">
					<Field
						name="currency"
						searchable={false}
						placeholder="Currencies"
						multi={true}
						component={SelectField}
						options={props.listOfCurrencies}
					/>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'finReportCurrenciesSelectForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/fin-reports/components/currencies-select-form.js